module.exports = __webpack_public_path__ + "media/icons/bwr_small-75bc2d08.png";